import React from "react";
import { Box } from "@mui/material";
import UserChangePasswordForm from "./UserChangePasswordForm";
import UserProfilePermissions from "./UserProfilePermissions";
import "./UserProfile.css";

const UserProfile = () => {
  return (
    <Box className="user-profile-layout">
      <Box className="user-profile-left">
        <UserProfilePermissions />
      </Box>
      <Box className="user-profile-password">
        <UserChangePasswordForm />
      </Box>
    </Box>
  );
};

export default UserProfile;
